/** From Flutter `app_ru.arb` — privacyPolicy* / termsOfService*. */
export const legalMessagesRu = {
  privacy: {
    pageTitle: "Политика конфиденциальности",
    lastUpdated: "Последнее обновление: 1 июня 2026 г.",
    introduction: {
      title: "Введение",
      body: "WasOK — локальное приложение-помощник для покупок, которое помогает пользователям запоминать товары, которые они ранее покупали, оценивали или о которых оставляли отзывы.\n\nНастоящая Политика конфиденциальности объясняет, какая информация обрабатывается при использовании приложения, как хранятся данные и как могут работать некоторые сторонние сервисы.",
    },
    dataStored: {
      title: "Данные, хранимые приложением",
      body: "WasOK хранит следующую информацию локально на вашем устройстве:\n\n• отсканированные штрихкоды товаров\n• названия и сведения о товарах, введённые пользователем\n• оценки и комментарии\n• списки покупок\n• категории товаров\n• цены и информация о магазинах\n• фотографии товаров и магазинов\n\nДанные о ваших товарах и фотографии не загружаются на серверы WasOK.",
    },
    permissions: {
      title: "Используемые разрешения",
      camera: {
        title: "Камера",
        body: "Доступ к камере используется для:\n\n• сканирования штрихкодов\n• съёмки фотографий товаров",
      },
      photos: {
        title: "Фото и медиа",
        body: "Доступ к фото или галерее используется только когда:\n\n• вы прикрепляете изображения к товарам\n• вы восстанавливаете резервные копии с фотографиями",
      },
      files: {
        title: "Доступ к файлам и хранилищу",
        body: "Доступ к файлам может использоваться для:\n\n• экспорта файлов резервных копий\n• импорта резервных копий, выбранных пользователем\n• отправки списков покупок или резервных копий",
      },
    },
    backup: {
      title: "Резервное копирование и экспорт",
      body: "WasOK позволяет создавать файлы резервных копий с данными приложения и, при необходимости, фотографиями.\n\nФайлы резервных копий создаются локально на вашем устройстве и могут быть сохранены или переданы через сервисы, которые вы выбираете, например:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• локальное хранилище устройства\n\nWasOK не загружает резервные копии на собственные серверы.",
      onlineProductLookup: {
        title: "Онлайн-поиск товара",
        body: "Если в настройках включён онлайн-поиск по штрихкоду, WasOK может отправлять в публичные базы данных (например, Open Food Facts) только номер отсканированного штрихкода, чтобы предложить название и бренд. WasOK не передаёт оценки, комментарии, фото, списки покупок, категории, данные магазинов и резервные копии. Функцию можно отключить в любой момент в настройках.",
      },
    },
    advertising: {
      title: "Реклама и сторонние сервисы",
      intro:
        "WasOK использует отдельные сторонние сервисы для предоставления определённых функций.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob используется для показа рекламы в приложении.\n\nGoogle и её партнёры могут обрабатывать информацию, такую как:\n\n• рекламные идентификаторы\n• сведения об устройстве\n• IP-адрес\n• диагностическую информацию и данные об использовании\n\nПользователям в некоторых регионах может быть предложено дать согласие перед показом персонализированной рекламы.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK использует Firebase Crashlytics для выявления сбоев и повышения стабильности приложения.\n\nОтчёты о сбоях могут включать техническую информацию, такую как:\n\n• модель устройства\n• версия операционной системы\n• версия приложения\n• диагностика сбоев\n\nОтчёты о сбоях намеренно не включают ваши оценки товаров, заметки, списки покупок или фото.",
      },
      externalProductDatabases: {
        title: "Внешние базы данных товаров",
        body: "Функция поиска по штрихкоду может использовать внешние базы данных товаров для получения информации о продукте.\n\nДополнительную информацию см. в политиках конфиденциальности соответствующих поставщиков.",
      },
    },
    dataSecurity: {
      title: "Безопасность данных",
      body: "WasOK хранит данные приложения локально на вашем устройстве с использованием механизмов хранения, предоставляемых операционной системой.\n\nНесмотря на разумные меры защиты локальных данных приложения, ни один метод электронного хранения не является абсолютно безопасным.\n\nПользователи сами отвечают за сохранение резервных копий важных данных при необходимости.",
    },
    children: {
      title: "Конфиденциальность детей",
      body: "WasOK не предназначено для детей младше 13 лет.",
    },
    notifications: {
      title: "Уведомления",
      body: "WasOK может необязательно создавать локальные уведомления на вашем устройстве, напоминая оценить товары после покупки.\n\nЭти уведомления формируются и планируются локально на вашем устройстве и не требуют аккаунта или удалённого сервера.\n\nВы можете отключить уведомления в любое время в настройках устройства или в приложении, если это поддерживается.",
    },
    yourControl: {
      title: "Ваш контроль над данными",
      body: "Вы можете:\n\n• редактировать или удалять сохранённые товары в любое время\n• очистить данные приложения на устройстве\n• удалить приложение\n• экспортировать резервные копии своих данных",
    },
    changes: {
      title: "Изменения политики",
      body: "Настоящая Политика конфиденциальности может время от времени обновляться.\n\nИзменения вступают в силу после публикации обновлённой версии.",
    },
    contact: {
      title: "Контакты",
      body: "Если у вас есть вопросы по этой Политике конфиденциальности, напишите:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Условия предоставления услуг",
    lastUpdated: "Последнее обновление: 1 июня 2026 г.",
    acceptance: {
      title: "Принятие условий",
      body: "Загружая, устанавливая или используя WasOK, вы соглашаетесь с настоящими Условиями предоставления услуг.\n\nЕсли вы не согласны с этими Условиями, не используйте приложение.",
    },
    license: {
      title: "Лицензия",
      body: "WasOK предоставляет вам ограниченную, неисключительную, непередаваемую, отзывную лицензию на использование приложения в соответствии с настоящими Условиями.",
    },
    acceptableUse: {
      title: "Допустимое использование",
      body: "Вы соглашаетесь не:\n\n• злоупотреблять приложением\n• мешать работе приложения\n• пытаться проводить реверс-инжиниринг или изменять приложение\n• использовать приложение с нарушением применимых законов или нормативных актов",
    },
    localData: {
      title: "Локальные данные и резервные копии",
      body: "WasOK хранит пользовательские данные локально на устройстве.\n\nПользователи сами отвечают за сохранение резервных копий важных данных при необходимости.\n\nХотя может быть доступна функция резервного копирования и восстановления, WasOK не гарантирует отсутствие потери, повреждения или сбоя хранимых данных.",
    },
    advertisements: {
      title: "Реклама",
      body: "В приложении может отображаться реклама, предоставляемая сторонними рекламными партнёрами, включая Google AdMob.",
    },
    noWarranty: {
      title: "Отказ от гарантий",
      body: "WasOK предоставляется «как есть» и «по мере доступности» без каких-либо явных или подразумеваемых гарантий.\n\nМы не гарантируем, что:\n\n• приложение всегда будет доступно\n• приложение будет работать без ошибок\n• потери данных никогда не произойдёт\n• все функции будут бесперебойно работать на всех устройствах",
    },
    limitationLiability: {
      title: "Ограничение ответственности",
      body: "В максимальной степени, разрешённой законом, WasOK и её разработчики не несут ответственности за:\n\n• потерю данных\n• упущенную выгоду\n• проблемы с устройством\n• косвенный или последующий ущерб\n• перерывы, связанные с использованием или невозможностью использования приложения",
    },
    thirdParty: {
      title: "Сторонние сервисы",
      body: "Некоторые функции или контент могут зависеть от сторонних сервисов, включая рекламных провайдеров и внешние сервисы хранения или обмена, выбранные пользователем.\n\nWasOK не несёт ответственности за сторонние сервисы или их политики.",
    },
    productInformation: {
      title: "Информация о товарах",
      body: "Некоторые сведения о товарах могут быть получены из сторонних сервисов поиска по штрихкоду.\n\nWasOK не гарантирует точность, полноту, доступность или пригодность информации, предоставляемой внешними источниками данных.\n\nПользователям следует самостоятельно проверять информацию о товарах при необходимости.",
    },
    changesApp: {
      title: "Изменения приложения",
      body: "WasOK может быть изменено, обновлено, приостановлено или прекращено в любое время без предварительного уведомления.",
    },
    changesTerms: {
      title: "Изменения настоящих Условий",
      body: "Настоящие Условия могут периодически обновляться.\n\nПродолжение использования приложения после вступления обновлений в силу означает принятие пересмотренных Условий.",
    },
    contact: {
      title: "Контакты",
      body: "По вопросам, связанным с настоящими Условиями, пишите:\n\nsupport@wasok.app",
    },
  },
};
